"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchJobAreaDictData = exports.getLivingAreaDictData = exports.getLivingAreaChildDictData = exports.getLivdingAreaData = exports.getGraduatesDictData = exports.getDictTranslate = exports.getDictData = exports.getCityLevelDictData = exports.getCityDictData = exports.filterDictData = void 0;
var _jbsComponentsUtils = require("@51job/jbs-components-utils");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var baseUrl = "https://js.51jobcdn.com/in/js/2023/dd/";
var Role = {
  filterDictDataUrl: "/open/noauth/dictionary-associate/function-type",
  livingAreaDictDataUrl: "/open/noauth/dictionary/living-area",
  searchJobAreaDictDataUrl: '/open/noauth/dictionary/search-job-area'
};

// 清除历史遗留的缓存
try {
  localStorage.removeItem('dictVersion_funtype_standard');
  localStorage.removeItem('dictVersion_funtype_campus');
  localStorage.removeItem('dictData_funtype_standard');
  localStorage.removeItem('dictData_funtype_campus');
  localStorage.removeItem('dictVersion_major');
  localStorage.removeItem('dictData_major');
  localStorage.removeItem('dictVersion_certification_list');
  localStorage.removeItem('dictData_certification_list');
  localStorage.removeItem('dictVersion_it_skill_list');
  localStorage.removeItem('dictData_it_skill_list');
  localStorage.removeItem('dictVersion_industry');
  localStorage.removeItem('dictData_industry');
  localStorage.removeItem('dictVersion_city');
  localStorage.removeItem('dictData_city');
  localStorage.removeItem('dictVersion_funtype_translation');
  localStorage.removeItem('dictData_funtype_translation');
  localStorage.removeItem('dictVersion_living_area_pc');
  localStorage.removeItem('dictData_living_area_pc');
  localStorage.removeItem('dictFunListVersion');
  localStorage.removeItem('dictFunList_51job');
  localStorage.removeItem('dictFunList_translation');
  localStorage.removeItem('dictFunList_school');
} catch (error) {
  console.log(error);
}
var version = null;

// 、、获取字典  type -> standard 社招 ，  campus应届生
var getDictData = exports.getDictData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var type,
      result,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          type = _args.length > 0 && _args[0] !== undefined ? _args[0] : "standard";
          _context.next = 3;
          return getDictDataVersion();
        case 3:
          result = _context.sent;
          return _context.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_funtype_").concat(type, ".json?t=").concat(result),
            method: "GET"
          }).then(function (res) {
            return res;
          }));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDictData() {
    return _ref.apply(this, arguments);
  };
}();
// 、、获取应届生字典 
var getGraduatesDictData = exports.getGraduatesDictData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(name, dictVersion) {
    var result;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getDictDataVersion();
        case 2:
          result = _context2.sent;
          return _context2.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_").concat(name).concat(dictVersion ? '_' + dictVersion : '', ".json?t=").concat(result),
            method: "GET"
          }).then(function (res) {
            return res;
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getGraduatesDictData(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

// 、、获取城市字典 
var getCityDictData = exports.getCityDictData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getDictDataVersion();
        case 2:
          result = _context3.sent;
          return _context3.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_city.json?t=").concat(result),
            method: "GET"
          }).then(function (res) {
            return res;
          }));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getCityDictData() {
    return _ref3.apply(this, arguments);
  };
}();

// 、、获取含层级结构的城市字典 
var getCityLevelDictData = exports.getCityLevelDictData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var result;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getDictDataVersion();
        case 2:
          result = _context4.sent;
          return _context4.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_area_translation.json?t=").concat(result),
            method: "GET"
          }).then(function (res) {
            return res;
          }));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getCityLevelDictData() {
    return _ref4.apply(this, arguments);
  };
}();
// 、、获取页面
var filterDictData = exports.filterDictData = function filterDictData(params) {
  var newurl = Role.filterDictDataUrl + '?api_key=51job&timestamp=' + parseInt(new Date().getTime() / 1000);
  if (JSON.stringify(params) != '{}') {
    var getParamArr = [];
    for (var k in params) {
      if (params[k] && typeof params[k] == 'string') {
        params[k] = params[k].replace(/'/g, "");
      }
      getParamArr.push('&' + k + '=' + encodeURIComponent(params[k]));
    }
    newurl = newurl + getParamArr.join('');
  }
  return (0, _jbsComponentsUtils.request)({
    url: 'https://cupid.51job.com' + newurl,
    method: "GET",
    headers: {
      sign: _jbsComponentsUtils.CryptoJS.HmacSHA256(newurl, 'abfc8f9dcf8c3f3d8aa294ac5f2cf2cc7767e5592590f39c3f503271dd68562b').toString(_jbsComponentsUtils.CryptoJS.enc.Hex)
    }
  });
};
var getDictDataVersion = function getDictDataVersion() {
  return new Promise(function (resolve) {
    if (version) {
      resolve(version);
    } else {
      (0, _jbsComponentsUtils.request)({
        url: "".concat(baseUrl, "version.json?").concat(Date.parse(new Date())),
        method: "GET"
      }).then(function (res) {
        version = res;
        resolve(version);
      });
    }
  });
};
var getDictTranslate = exports.getDictTranslate = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var result;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getDictDataVersion();
        case 2:
          result = _context5.sent;
          return _context5.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_funtype_translation.json?t=").concat(result),
            method: 'GET'
          }).then(function (res) {
            return res;
          }));
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getDictTranslate() {
    return _ref5.apply(this, arguments);
  };
}();
// 获取现居地数据
var getLivdingAreaData = exports.getLivdingAreaData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var result;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return getDictDataVersion();
        case 2:
          result = _context6.sent;
          return _context6.abrupt("return", (0, _jbsComponentsUtils.request)({
            url: "".concat(baseUrl, "dd_living_area_pc.json?t=").concat(result),
            method: 'GET'
          }).then(function (res) {
            return res;
          }));
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getLivdingAreaData() {
    return _ref6.apply(this, arguments);
  };
}();

// 居住地地区数据字典
var getLivingAreaDictData = exports.getLivingAreaDictData = function getLivingAreaDictData(params) {
  var newurl = Role.livingAreaDictDataUrl + '?api_key=51job&timestamp=' + parseInt(new Date().getTime() / 1000);
  if (JSON.stringify(params) != '{}') {
    var getParamArr = [];
    for (var k in params) {
      if (params[k] && typeof params[k] == 'string') {
        params[k] = params[k].replace(/'/g, "");
      }
      getParamArr.push('&' + k + '=' + encodeURIComponent(params[k]));
    }
    newurl = newurl + getParamArr.join('');
  }
  return (0, _jbsComponentsUtils.request)({
    url: 'https://cupid.51job.com' + newurl,
    method: "GET",
    headers: {
      sign: _jbsComponentsUtils.CryptoJS.HmacSHA256(newurl, 'abfc8f9dcf8c3f3d8aa294ac5f2cf2cc7767e5592590f39c3f503271dd68562b').toString(_jbsComponentsUtils.CryptoJS.enc.Hex)
    }
  });
};

// 居住地地区数据字典 子项
var getLivingAreaChildDictData = exports.getLivingAreaChildDictData = function getLivingAreaChildDictData(params, code) {
  var newurl = Role.livingAreaDictDataUrl + '/' + code + '?api_key=51job&timestamp=' + parseInt(new Date().getTime() / 1000);
  if (JSON.stringify(params) != '{}') {
    var getParamArr = [];
    for (var k in params) {
      if (params[k] && typeof params[k] == 'string') {
        params[k] = params[k].replace(/'/g, "");
      }
      getParamArr.push('&' + k + '=' + encodeURIComponent(params[k]));
    }
    newurl = newurl + getParamArr.join('');
  }
  return (0, _jbsComponentsUtils.request)({
    url: 'https://cupid.51job.com' + newurl,
    method: "GET",
    headers: {
      sign: _jbsComponentsUtils.CryptoJS.HmacSHA256(newurl, 'abfc8f9dcf8c3f3d8aa294ac5f2cf2cc7767e5592590f39c3f503271dd68562b').toString(_jbsComponentsUtils.CryptoJS.enc.Hex)
    }
  });
};

// 搜索筛选项地区数据字典
var getSearchJobAreaDictData = exports.getSearchJobAreaDictData = function getSearchJobAreaDictData(params) {
  var newurl = Role.searchJobAreaDictDataUrl + '?api_key=51job&timestamp=' + parseInt(new Date().getTime() / 1000);
  if (JSON.stringify(params) != '{}') {
    var getParamArr = [];
    for (var k in params) {
      if (params[k] && typeof params[k] == 'string') {
        params[k] = params[k].replace(/'/g, "");
      }
      getParamArr.push('&' + k + '=' + encodeURIComponent(params[k]));
    }
    newurl = newurl + getParamArr.join('');
  }
  return (0, _jbsComponentsUtils.request)({
    url: 'https://cupid.51job.com' + newurl,
    method: "GET",
    headers: {
      sign: _jbsComponentsUtils.CryptoJS.HmacSHA256(newurl, 'abfc8f9dcf8c3f3d8aa294ac5f2cf2cc7767e5592590f39c3f503271dd68562b').toString(_jbsComponentsUtils.CryptoJS.enc.Hex)
    }
  });
};